import styled from 'styled-components';
import { themeGet } from '../../foundation/theme/themeGet/get.js';
import { pxToRem, unit } from '../../foundation/spacing/utils.js';

var BORDER_RADIUS = themeGet('borderRadius.md');
var getBackgroundColor = function getBackgroundColor(appearance) {
  switch (appearance) {
    case 'primary':
      return themeGet('colors.secondary.50');
    case 'secondary':
      return themeGet('colors.brandPrimary.50');
    case 'success':
      return themeGet('colors.green.50');
    case 'danger':
      return themeGet('colors.red.50');
    case 'warning':
      return themeGet('colors.yellow.50');
    case 'info':
    default:
      return themeGet('colors.blue.50');
  }
};
var getColor = function getColor(appearance) {
  switch (appearance) {
    case 'primary':
      return themeGet('colors.secondary.500');
    case 'secondary':
      return themeGet('colors.brandPrimary.500');
    case 'success':
      return themeGet('colors.green.500');
    case 'danger':
      return themeGet('colors.red.500');
    case 'warning':
      return themeGet('colors.yellow.500');
    case 'info':
    default:
      return themeGet('colors.blue.500');
  }
};
var Wrapper = styled.div.withConfig({
  displayName: "Wrapper",
  componentId: "sc-1pg97e6-0"
})(["border-left:", " solid ", ";border-radius:", ";"], pxToRem(6), function (props) {
  return getColor(props.$appearance);
}, BORDER_RADIUS);
var Container = styled.div.withConfig({
  displayName: "Container",
  componentId: "sc-1pg97e6-1"
})(["display:flex;flex-direction:column;padding:", ";background-color:", ";border:", " solid ", ";border-left:none;border-top-right-radius:", ";border-bottom-right-radius:", ";"], unit('xl'), function (props) {
  return props.$pale ? getBackgroundColor(props.$appearance) : themeGet('colors.background.50');
}, pxToRem(1), themeGet('colors.border.100'), BORDER_RADIUS, BORDER_RADIUS);
var TextContainer = styled.div.withConfig({
  displayName: "TextContainer",
  componentId: "sc-1pg97e6-2"
})(["display:flex;flex-direction:column;justify-content:center;align-items:flex-start;"]);
var ButtonContainer = styled.div.withConfig({
  displayName: "ButtonContainer",
  componentId: "sc-1pg97e6-3"
})(["display:flex;flex-direction:row-reverse;justify-content:flex-start;align-items:center;gap:", ";margin-top:", ";"], unit('md'), unit('md'));

export { ButtonContainer, Container, TextContainer, Wrapper, getBackgroundColor, getColor };
